import { fDateTime } from './formatTime';

/**
 * 최근 수정자와 수정일을 반환하는 함수
 * @param updUser 수정자
 * @param updDt 수정일
 * @returns `updated by ${updUser} (${format(new Date(updDt), DATETIME_FORMAT)})`
 */
function getLastUpdatedText(updUser: string, updDt: string | number) {
  return `updated by ${updUser} (${fDateTime(updDt)})`;
}

export default getLastUpdatedText;
